module.exports = ["cent","copy","divide","gt","lt","not","para","times"]


//////////////////
// WEBPACK FOOTER
// ../node_modules/stringify-entities/dangerous.json
// module id = 914
// module chunks = 0